import { createSlice } from "@reduxjs/toolkit";

const initialBorrowState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  borrowForEdit: undefined,
  lastError: null,
  message: null,
  error: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const borrowSlice = createSlice({
  name: "borrows",
  initialState: initialBorrowState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error.clientMessage;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.message = null;

      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      state.message = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    // getBorrowById
    borrowFetched: (state, action) => {
      state.actionsLoading = false;
      state.borrowForEdit = action.payload.borrowForEdit;
      state.floorPlans = action.payload.borrowForEdit.floorPlans;
      state.error = null;
    },
    // getBorrowChart
    borrowChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.borrowChart = action.payload.borrowChart;
      state.error = null;
    },
    // getBorrowChart
    borrowHourlyChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.borrowChartHour = action.payload.borrowChartHour;
      state.error = null;
    },
    // getBorrowChart
    borrowHourlyZoneChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.borrowChartHourZone = action.payload.borrowChartHourZone;
      state.error = null;
    },
    // get list data
    borrowsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.borrowForEdit = undefined;
      state.floorPlans = undefined;
      state.borrowChart = undefined;
      state.borrowChartHour = undefined;
      state.borrowChartHourZone = undefined;
    },
    // createBorrow
    borrowCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.message = action.payload.msgResponse;
    },
    // updateBorrow
    borrowUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.message = action.payload.msgResponse;
      // Update state
      if (action.payload.borrowId) {
        state.entities = state.entities.map((item) => {
          if (item.id === action.payload.borrowId) {
            return { ...item, ...action.payload.borrow };
          } else {
            return item;
          }
        });
      }
    },
    // borrowDeleted
    borrowDeleted: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
      state.actionsLoading = false;
    },
    setMessage: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
    },
    floorPlanDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.floorPlans = state.floorPlans.filter(
        (item) => item.id !== action.payload.id
      );
    },
    floorPlanUpdated: (state, action) => {
      const { id, floorPlan } = action.payload;
      state.error = null;
      state.actionsLoading = false;
      state.floorPlans = state.floorPlans.map((data) => {
        if (data.id === id) {
          return floorPlan;
        }

        return data;
      });
    },
  },
});
